import { CSSProperties } from "@material-ui/core/styles/withStyles";

// styles
import { greys } from "@styles/color.styles";
import { fontFamilySans } from "@styles/type.styles";

const textContainer: CSSProperties = {
  position: "relative",
  height: "100%",
  width: 75,
  fontFamily: fontFamilySans,
  fontSize: 12,
  color: greys.slate,
  borderRight: `1px solid ${greys.borderGrey}`,
};

const text: CSSProperties = {
  zIndex: 3,
  marginTop: -6,
  right: 25,
  position: "absolute",
};

export const styles = { textContainer, text };
